import logoComponayPlaceholder from '@/public/images/skyline.png';
// import BookmarkIcon from '@mui/icons-material/Bookmark';
import Icon from '@mui/material/Icon';
// import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import Image from 'next/image';

import Box from '@mui/material/Box';
// import Checkbox from '@mui/material/Checkbox';

import { HOME_URL } from '@/constants';
import { WAYS_OF_CONTACT_MAP } from '@/constants/ways-of-contact-map';
import JobService from '@/services/Job.service';
import styles from '@/styles/job-details-card.module.css';
import { Job } from '@/types/job';
import { fakeSlug } from '@/utils/fake-slug';
import Link from '@/components/link-with-utms';
import React from 'react';
import ShareJobButton from '../modals/share-job-button';
import { ContainerLinkDetails } from './job-details-card';
import { validWaysOfContact } from './valid-ways-of-contact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { IconPcd } from './icon-pdc';
import { nameMask } from '@/utils/name-mask';
import { formatJobTitle } from '@/utils/format-job-title';

// const check = { inputProps: { 'aria-label': `Checkbox demo` } };

interface JobDetailsCardHeaderProps {
  titleWithH1?: boolean;
  job: Job;
  showContactWithCompany?: boolean;
  showShareButton?: boolean;
  linkToSearch?: boolean;
  linkToDetails?: boolean;
}

export default class JobDetailsCardHeader extends React.Component<JobDetailsCardHeaderProps, { logoBase64: string }> {
  constructor(props: JobDetailsCardHeaderProps) {
    super(props);
    this.state = {
      logoBase64: ``,
    };

    this.loadCompanyLogo = this.loadCompanyLogo.bind(this);
  }

  loadCompanyLogo() {
    JobService.fetchJobCompanyLogo(this.props.job.id).then((logoBase64) => {
      this.setState({ logoBase64 });
    });
  }

  componentDidMount(): void {
    this.loadCompanyLogo();
  }

  componentDidUpdate(prevProps: Readonly<JobDetailsCardHeaderProps>): void {
    if (this.props.job.id !== prevProps.job.id) {
      this.loadCompanyLogo();
    }
  }

  render(): React.ReactNode {
    const {
      titleWithH1,
      job,
      showContactWithCompany = true,
      showShareButton = false,
      linkToSearch = false,
      linkToDetails = false,
    } = this.props;

    const companyLogo = this.state.logoBase64 || logoComponayPlaceholder;

    const { companyName, city, state, roleCode, roleSlug } = job;
    const title = formatJobTitle(job.title);

    const ways = validWaysOfContact(job);

    const companyNameFormatted = companyName.toLowerCase().includes('empresa confidencial')
      ? 'Empresa Confidencial'
      : nameMask(companyName);

    return (
      <Box className={styles.header}>
        <ContainerLinkDetails job={job} linkToDetails={linkToDetails}>
          <Box className={styles.row + (showShareButton ? ` ` + styles.title : ``)}>
            <div className={styles.img}>
              <Image
                src={companyLogo}
                alt={`${title} - ${companyName} - ${city} - ${state}`}
                fill
                style={{ objectFit: 'contain' }}
              />
            </div>
            <div>
              <div className={styles.title}>{titleWithH1 ? <h1>{title}</h1> : <h2>{title}</h2>}</div>
            </div>
            {!showShareButton && job.pcd && (
              <Icon className={styles.pcd_icon} role="img" aria-label="Vaga para pessoa com deficiência">
                <FontAwesomeIcon icon={faWheelchair} style={{ color: `#373F41` }} />
              </Icon>
            )}
            {showShareButton && job.pcd && <IconPcd />}
          </Box>
          <Box className={styles.row}>
            <Box className={styles.job_company_location}>
              <p className={styles.company_location}>
                {linkToSearch ? (
                  <>
                    {companyName.toLowerCase().includes(`empresa confidencial`) ? (
                      <span className={styles.company_name}>{companyNameFormatted}</span>
                    ) : (
                      <Link href={`/vagas/empresa/${fakeSlug(companyName)}`} className={styles.company_name}>
                        {companyNameFormatted}
                      </Link>
                    )}
                    <Link
                      href={`/vagas/cargo/${roleCode}-${roleSlug}?cidade=${job.cityId}`}
                      className={styles.location}
                    >
                      {city && ` - ${city} - ${state}`}
                    </Link>
                  </>
                ) : (
                  <>
                    <b className={styles.company_name}>{companyNameFormatted}</b>
                    <span className={styles.location}>{city && ` - ${city} - ${state}`}</span>
                  </>
                )}
              </p>
              {job.companyField && (
                <p>
                  <b>Ramo da empresa: </b>
                  {job.companyField}
                </p>
              )}
              {showContactWithCompany && (
                <p>
                  <b>
                    {job.connekt
                      ? `Contato via empresa recrutadora: `
                      : `Formas de contato disponibilizadas pela empresa: `}
                  </b>
                  {ways.length === 0 ? `Envio de currículo` : ways.map((way) => WAYS_OF_CONTACT_MAP[way]).join(`, `)}
                </p>
              )}
            </Box>
          </Box>
        </ContainerLinkDetails>
        {showShareButton && (
          <Box className={`actions ${styles.actions}`}>
            <ShareJobButton link={`${HOME_URL}/vagas/emprego/${job.slug}`} utmContent="job_detail" />
            {/* <Checkbox {...check} icon={<BookmarkBorderIcon />} checkedIcon={<BookmarkIcon />} /> */}
          </Box>
        )}
      </Box>
    );
  }
}
